import { useSearchParams } from 'react-router';
import ListInsurance from './ListInsurance';
import FormInsurance from './FormInsurance';

export default function Insurance() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'list';

  return (
    <div>
      {activeTab === 'list' && <ListInsurance />}
      {activeTab === 'form' && <FormInsurance />}
    </div>
  );
}
